/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { UserProfileDto } from '@gh/common-shared-data';
import { BitSet } from '@gh/core-data';

import { MasterZoneListItemDto } from '../master-zones/master-zone-list-item.dto';
import { OfficeDto } from '../offices/models/office.dto';
import { UserAllowAccess } from '../users/user-details.dto';
import { UserType } from '../users/user-type.enum';
import { ApplicationView } from './application-view.enum';
import { SystemRoleBit } from './system-role.enum';
import { ValidationStatus } from './validation-status.enum';

export class BuilderUserProfileValidationDto {
  paymentStatus: ValidationStatus;

  [name: string]: any;
}

export type BuilderUserProfileDto = UserProfileDto & {
  appView: ApplicationView;
  office?: OfficeDto;
  masterZone?: MasterZoneListItemDto;
  type: UserType;
  systemRoles: BitSet<SystemRoleBit>;
  modulePermissions?: string[];
  validationResult: BuilderUserProfileValidationDto;
  allowAccessToLeads?: UserAllowAccess;
  zoneId: string;
  jasperReportsUrl: string;
  jasperCommercialStatus: string;
  jasperCommercialUrl: string;
  currentDateTime: Date;
  planBankUrl: string;

  talentLmsUrl: string;
  acceptanceUsePolicyDocumentUrl: string;
  colorScheme: string;
  isCalendarEmpty: boolean;
  calendarWarningDays?: number;
  hasAgreements: boolean;
  hasUnacceptedAgreements: boolean;
  profilePicture?: any;
  masterZoneName?: string;
  accountingVersion?: string;
  serviceRequestFormHMAC: string;
  isStripeEnabled?: boolean;
  canToggleStripeStatus?: boolean;
};
